const countries = [
  { text: "Arabic", key: "ar-sa" },
  { text: "Bulgarian", key: "bg-bg" },
  { text: "Catalan", key: "ca-es" },
  { text: "Czech", key: "cs-cz" },
  { text: "Danish", key: "da-dk" },
  { text: "German", key: "de-de" },
  { text: "Greek", key: "el-gr" },
  { text: "English (UK)", key: "en-gb" },
  { text: "English (US)", key: "en-us" },
  { text: "Spanish", key: "es-es" },
  { text: "Spanish (Mexican)", key: "es-mx" },
  { text: "Estonian", key: "et-ee" },
  { text: "Basque", key: "eu-es" },
  { text: "Finnish", key: "fi-fi" },
  { text: "Filipino", key: "fil-ph" },
  { text: "French", key: "fr-fr" },
  { text: "French (CA)", key: "fr-ca"},
  { text: "Galician", key: "gl-es" },
  { text: "Hebrew", key: "he-il" },
  { text: "Hindi", key: "hi-in" },
  { text: "Croatian", key: "hr-hr" },
  { text: "Hungarian", key: "hu-hu" },
  { text: "Indonesian", key: "id-id" },
  { text: "Italian", key: "it-it" },
  { text: "Japanese", key: "ja-jp" },
  { text: "Kazakh", key: "kk-kz" },
  { text: "Korean", key: "ko-kr" },
  { text: "Lithuanian", key: "lt-lt" },
  { text: "Latvian", key: "lv-lv" },
  { text: "Malay", key: "ms-my" },
  { text: "Norwegian (Bokmal)", key: "nb-no" },
  { text: "Dutch", key: "nl-nl" },
  { text: "Polish", key: "pl-pl" },
  { text: "Portuguese (Brazil)", key: "pt-br" },
  { text: "Portuguese (Portugal)", key: "pt-pt" },
  { text: "Romanian", key: "ro-ro" },
  { text: "Russian", key: "ru-ru" },
  { text: "Slovak", key: "sk-sk" },
  { text: "Slovenian", key: "sl-si" },
  { text: "Serbian (Cyrillic)", key: "sr-cyrl-rs" },
  { text: "Serbian (Latin)", key: "sr-latn-rs" },
  { text: "Swedish", key: "sv-se" },
  { text: "Thai", key: "th-th" },
  { text: "Turkish", key: "tr-tr" },
  { text: "Ukrainian", key: "uk-ua" },
  { text: "Vietnamese", key: "vi-vn" },
  { text: "Chinese (Simplified, Singapore)", key: "zh-sg" },
  { text: "Chinese (Traditional, Taiwan)", key: "zh-tw" },
  { text: "Chinese (Traditional, Hong Kong SAR)", key: "zh-hk" },
  { text: "Chinese (Simplified, China)", key: "zh-cn" },
  { text: "Albanian", key: "sq-al" },
  { text: "Azerbaijan", key: "az-latn-az" },
  { text: "Bosnian Latin", key: "bs-latn-ba" },
  { text: "Georgian", key: "ka-ge" },
  { text: "Macedonian", key: "mk-mk" },
  { text: "Montenegrin", key: "sr-latn-me" }
];

export default countries;
